var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app5"}},[_c('Carousel_cards',{attrs:{"vertical":false,"verticalS":false,"items":4,"rows":1,"controls":false,"texts":_vm.texts,"names":_vm.names}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }